const MasterClockActionTypes = {
    INIT_TIMER : 'INIT_TIMER',
    TIMER_STARTED : 'TIMER_STARTED',
    GET_CURRENT_TICK_TIME : 'GET_CURRENT_TICK_TIME',
    STOP_FARM : 'STOP_FARM',
    UPDATE_TICK_TIME : 'UPDATE_TICK_TIME',
}

export default MasterClockActionTypes